import { Badge } from "@shopify/polaris";

// traslado_orders.status lifecycle. "historical" rows were backfilled from past
// broker invoices (TrasladoRecovery) and never went through this flow.
export const TRASLADO_STATUS = {
  draft: { label: "Cotización", tone: undefined },
  authorized: { label: "Autorizado", tone: "info" },
  in_progress: { label: "En camino", tone: "attention" },
  completed: { label: "Entregado", tone: "success" },
  settled: { label: "Liquidado", tone: "success" },
  cancelled: { label: "Cancelado", tone: "critical" },
  historical: { label: "Histórico", tone: undefined },
};

// Forward transitions offered on the detail page.
export const NEXT_STATUS = {
  draft: [{ to: "authorized", label: "Autorizar" }],
  authorized: [{ to: "in_progress", label: "Marcar en camino" }],
  in_progress: [{ to: "completed", label: "Marcar entregado" }],
  // completed -> settled is not a status change: it's create_traslado_settlement
  // (Liquidación card), which computes and freezes what to pay. When everything
  // was already paid before delivery, "Cerrar traslado" (close_traslado) does it.
};

export function TrasladoStatusBadge({ status }) {
  const s = TRASLADO_STATUS[status];
  if (!s) return <Badge>{status}</Badge>;
  return <Badge tone={s.tone}>{s.label}</Badge>;
}

export const formatDuration = (min) => {
  if (min == null) return "—";
  const h = Math.floor(min / 60);
  const m = min % 60;
  return h ? `${h} h ${m} min` : `${m} min`;
};
